export default __webpack_public_path__ + "static/media/physical-info.0f6292a2.png";